import './App.css';
import { useState, useEffect } from "react"
import { projectURL } from './utils/mockdata';

const PrivacyPolicy = () => {

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen)
  }

  useEffect(() => {
    // Warm up the Render backend
    fetch(projectURL)
      .then(() => console.log("Render backend warmed up"))
      .catch((err) => console.warn("Render wake-up failed:", err));
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 via-white to-blue-50">

      {/* Header */}
      <header className="container mx-auto px-4 py-6">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-2">
            <div className="w-8 h-8 flex items-center justify-center">
              <img className="ring-2 ring-blue max-w-10 border rounded-full p-1.5" src="icon.jpg" alt="Socio" />
            </div>
            <span className="text-2xl font-bold bg-gradient-to-r from-purple-600 to-blue-600 bg-clip-text text-transparent">
              Socio
            </span>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <a href="/#features" className="text-gray-600 hover:text-purple-600 transition-colors">
              Features
            </a>
            <a href="/#community" className="text-gray-600 hover:text-purple-600 transition-colors">
              Community
            </a>
            <a href="/#about" className="text-gray-600 hover:text-purple-600 transition-colors">
              About
            </a>
            <a href="/login" className="px-4 py-2 border border-purple-200 text-purple-600 hover:bg-purple-50 bg-transparent rounded-md transition-colors">
              Log In
            </a>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={toggleMobileMenu}
            className="md:hidden p-2 rounded-md text-gray-600 hover:text-purple-600 hover:bg-gray-100 transition-colors"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              {isMobileMenuOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>

        {/* Mobile Navigation Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden mt-4 pb-4 border-t border-gray-200">
            <nav className="flex flex-col space-y-4 pt-4">
              <a
                href="/#features"
                className="text-gray-600 hover:text-purple-600 transition-colors py-2"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Features
              </a>
              <a
                href="/#community"
                className="text-gray-600 hover:text-purple-600 transition-colors py-2"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Community
              </a>
              <a
                href="/#about"
                className="text-gray-600 hover:text-purple-600 transition-colors py-2"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                About
              </a>
              <a target="__blank" href="/login" className="w-full mt-4 px-4 py-2 border border-purple-200 text-purple-600 hover:bg-purple-50 bg-transparent rounded-md transition-colors text-left">
                Log In
              </a>
            </nav>
          </div>
        )}
      </header>


      <div className="max-w-4xl mx-auto px-6 py-12 text-gray-800">
        <h1 className="text-3xl font-bold mb-6">Privacy Policy</h1>
        <p className="mb-4 text-sm text-gray-500">Effective Date: 07-07-2025</p>

        <p className="mb-4">
          Welcome to My Social Platform ("we", "our", or "us"). Your privacy is important to us.
          This Privacy Policy explains how we collect, use, disclose, and protect your information
          when you visit our website{" "}
          <a href="https://socioapp.live/" className="text-blue-600 underline">
            https://socioapp.live/
          </a>{" "}
          (the “Site”).
        </p>

        <p className="mb-4">
          By using the Site, you agree to the collection and use of information in accordance with this Privacy Policy.
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-4">1. Information We Collect</h2>

        <h3 className="text-xl font-medium mt-4 mb-2">a. Personal Information</h3>
        <ul className="list-disc list-inside mb-4">
          <li>Name</li>
          <li>Email address</li>
          <li>Username</li>
          <li>Profile photo</li>
          <li>Date of birth (if provided)</li>
        </ul>

        <h3 className="text-xl font-medium mt-4 mb-2">b. Usage Data</h3>
        <ul className="list-disc list-inside mb-4">
          <li>IP address</li>
          <li>Browser type and version</li>
          <li>Pages visited</li>
          <li>Time and date of visit</li>
          <li>Device identifiers</li>
        </ul>

        <h3 className="text-xl font-medium mt-4 mb-2">c. Cookies and Tracking</h3>
        <p className="mb-4">
          We use cookies and similar tracking technologies to track activity and enhance user experience.
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-4">2. How We Use Your Information</h2>
        <ul className="list-disc list-inside mb-4">
          <li>Provide and maintain our service</li>
          <li>Personalize user experience</li>
          <li>Communicate with you (e.g., updates, support)</li>
          <li>Improve our platform</li>
          <li>Prevent fraud and ensure security</li>
        </ul>

        <h2 className="text-2xl font-semibold mt-8 mb-4">3. Sharing Your Information</h2>
        <p className="mb-4">We do not sell or rent your personal information. However, we may share data with:</p>
        <ul className="list-disc list-inside mb-4">
          <li>Service providers (e.g., analytics tools, hosting)</li>
          <li>Legal authorities if required by law</li>
          <li>Other users (e.g., your public profile and posts)</li>
        </ul>

        <h2 className="text-2xl font-semibold mt-8 mb-4">4. Data Security</h2>
        <p className="mb-4">
          We implement appropriate security measures to protect your data. However, no method of transmission over
          the Internet is 100% secure.
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-4">5. Your Rights</h2>
        <p className="mb-4">
          Depending on your jurisdiction, you may have rights to:
        </p>
        <ul className="list-disc list-inside mb-4">
          <li>Access or correct your data</li>
          <li>Delete your account</li>
          <li>Object to processing</li>
          <li>Withdraw consent</li>
        </ul>
        <p className="mb-4">Contact us at <span className="font-medium">socioapplive@gmail.com</span> to exercise these rights.</p>

        <h2 className="text-2xl font-semibold mt-8 mb-4">6. Third-Party Links</h2>
        <p className="mb-4">
          Our site may contain links to third-party websites. We are not responsible for their privacy practices.
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-4">7. Children's Privacy</h2>
        <p className="mb-4">
          We do not knowingly collect personal information from children under 13. If you believe we have collected such data, please contact us immediately.
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-4">8. Changes to This Privacy Policy</h2>
        <p className="mb-4">
          We may update this policy from time to time. Changes will be posted on this page with a new “Effective Date.”
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-4">9. Contact Us</h2>
        <p className="mb-2">
          If you have questions or concerns about this Privacy Policy, contact us at:
        </p>
        <p className="font-medium">📧 Email: socioapplive@gmail.com</p>
      </div>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-4 gap-8">
            <div className="space-y-4">
              <div className="flex items-center space-x-2">
                <div className="w-8 h-8 flex items-center justify-center">
                  <img className="ring-2 ring-blue max-w-10 border rounded-full p-1.5" src="socio_icon-removebg-preview.png" alt="Socio" />
                </div>
                <span className="text-xl font-bold">Socio</span>
              </div>
              <p className="text-gray-400">Connecting people and communities around the world.</p>
            </div>

            <div>
              <h4 className="font-semibold mb-4">Product</h4>
              <ul className="space-y-2 text-gray-400">
                <li>
                  <a href="/#features" className="hover:text-white transition-colors">
                    Features
                  </a>
                </li>
                {/* <li>
                  <a href="#" className="hover:text-white transition-colors">
                    Pricing
                  </a>
                </li> */}
                <li>
                  <a href="Socio.apk" className="hover:text-white transition-colors">
                    Mobile App
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-semibold mb-4">Company</h4>
              <ul className="space-y-2 text-gray-400">
                <li>
                  <a href="/#about" className="hover:text-white transition-colors">
                    About
                  </a>
                </li>
                {/* <li>
                  <a href="#" className="hover:text-white transition-colors">
                    Careers
                  </a>
                </li>
                <li>
                  <a href="#" className="hover:text-white transition-colors">
                    Press
                  </a>
                </li> */}
              </ul>
            </div>

            <div>
              <h4 className="font-semibold mb-4">Support</h4>
              <ul className="space-y-2 text-gray-400">
                <li>
                  <a href="/HelpCenter" className="hover:text-white transition-colors">
                    Help Center
                  </a>
                </li>
                <li>
                  <a href="/PrivacyPolicy" className="hover:text-white transition-colors">
                    Privacy
                  </a>
                </li>
                <li>
                  <a href="/TermsOfService" className="hover:text-white transition-colors">
                    Terms
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
            <p>&copy; 2026 Socio. All rights reserved.</p>
          </div>
        </div>
      </footer>

    </div>
  );
};

export default PrivacyPolicy;

